import React, { FC } from "react"
import { graphql } from "gatsby"

import { TextBlockFragmentFragment } from "@graphqlTypes"

import LpSection from "../LpSection/LpSection"

const TextBlock: FC<TextBlockFragmentFragment> = ({
  background,
  contentful_id,
  ctaLink,
  ctaLinkSecondary,
  ctaText,
  ctaTextSecondary,
  includeBackground,
  marginBottom,
  subhead,
  text,
  title,
  useDarkMode,
}) => (
  <LpSection
    background={background}
    className="TextBlock"
    ctaLink={ctaLink}
    ctaLinkSecondary={ctaLinkSecondary}
    ctaText={ctaText}
    ctaTextSecondary={ctaTextSecondary}
    includeBackground={includeBackground}
    marginBottom={marginBottom}
    subhead={subhead}
    text={text}
    title={title}
    uniqueId={contentful_id}
    useDarkMode={useDarkMode}
  />
)

export const TextBlockFragment = graphql`
  fragment TextBlockFragment on ContentfulLpTextBlock {
    contentful_id
    title
    subhead
    text {
      raw
    }
    background
    ctaLink
    ctaLinkSecondary
    ctaText
    ctaTextSecondary
    includeBackground
    marginBottom
    useDarkMode
  }
`

export default TextBlock
